import { ccv, crv, cva } from '@/styled-system/css';

export const anchorRecipe = cva({
  base: {
    textDecoration: {
      base: 'underline',
    },
    textStyle: 'inherit',
    color: {
      base: 'text.link.default',
    },
    focusOutline: true,
  },
  variants: {
    disabled: {
      true: {
        cursor: 'default',
        opacity: 'disabled',
      },
      false: {
        color: {
          _hover: 'text.link.hover',
          _active: 'text.link.pressed',
          _focusVisible: 'text.link.hover',
          _visited: 'text.link.last-visited',
        },
        cursor: 'pointer',
      },
    },
    ...crv('onImpact', {
      true: {
        color: {
          base: 'text.onImpact.link.default',
        },
        textDecoration: {
          _hover: 'none',
        },
      },
      false: {},
    }),
  },
  compoundVariants: [
    ...ccv({
      onImpact: true,
      disabled: false,
      css: {
        color: {
          _hover: 'text.onImpact.link.hover',
          _active: 'Anchor.onImpact.pressed',
          _focusVisible: 'text.onImpact.link.hover',
          _visited: 'text.onImpact.link.last-visited',
        },
      },
    }),
  ],
});
